import React from 'react';
import classnames from 'classnames';
import DatePicker, { DatePickerProps } from '../../date-time-pickers/date-picker/date-picker';

export type FilterDatePickerProps = {
	className?: string;
	label?: string;
	dataTestId?: string;
} & DatePickerProps;

const FilterDatePicker: React.FunctionComponent<FilterDatePickerProps> = ({
	label,
	className,
	dataTestId,
	...otherProps
}) => {
	return (
		<div className={classnames('filter-item', className)} data-test-id={dataTestId}>
			{label && <label className="filters-search-label">{label}:</label>}
			<DatePicker {...otherProps} />
		</div>
	);
};

export default FilterDatePicker;
